import { ICarrier } from "../interfaces/configuration";
import { ALL_CARRIERS_OPTION_ID, ALL_MERCHANTS_OPTION_ID } from "./constants";

export const getListOfSelectedCarrierNames = (
  allCarriers: any[],
  selectedCarriers: any[]
) =>
  allCarriers
    .map(
      ({ _id, name: carrierName }) =>
        selectedCarriers.includes(_id) && carrierName
    )
    // Remove "false" strings
    .filter((name) => Boolean(name))
    .join(", ");

export const getMerchantsForFeeRule = (
  allMerchantIntegrations: number[],
  selectedMerchantIdsFromRule: number[]
) => {
  if (allMerchantIntegrations.length === 0) return [];
  const selectedMerchants = selectedMerchantIdsFromRule.filter((id: number) =>
    allMerchantIntegrations.includes(id)
  );
  return selectedMerchants.length > 0
    ? selectedMerchants
    : [ALL_MERCHANTS_OPTION_ID];
};

export const getCarriersForFeeRule = (
  allIntegratedCarriers: ICarrier[],
  selectedCarrierIdsFromRule: string[]
) => {
  if (allIntegratedCarriers.length === 0) return [];
  const selectedCarriers = allIntegratedCarriers.filter(({ carrier_id }) =>
    selectedCarrierIdsFromRule.includes(carrier_id)
  );
  const selectedCarriersIds = selectedCarriers.map(({ carrier_id }) => carrier_id);
  return selectedCarriers.length > 0
    ? selectedCarriersIds
    : [ALL_CARRIERS_OPTION_ID];
};
